var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0583 11.9165L17.725 16.0832C17.6 17.3582 17.5 18.3332 15.2416 18.3332H4.7583C2.49997 18.3332 2.39997 17.3582 2.27497 16.0832L1.94163 11.9165C1.87497 11.2248 2.09163 10.5832 2.4833 10.0915C2.49163 10.0832 2.49163 10.0832 2.49997 10.0748C2.9583 9.5165 3.64997 9.1665 4.42497 9.1665H15.575C16.35 9.1665 17.0333 9.5165 17.4833 10.0582C17.4916 10.0665 17.5 10.0748 17.5 10.0832C17.9083 10.5748 18.1333 11.2165 18.0583 11.9165Z",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 9.52523V5.23356C2.91675 2.40023 3.62508 1.69189 6.45842 1.69189H7.51675C8.57508 1.69189 8.81675 2.00856 9.21675 2.54189L10.2751 3.95856C10.5417 4.30856 10.7001 4.52523 11.4084 4.52523H13.5334C16.3667 4.52523 17.0751 5.23356 17.0751 8.06689V9.55856",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8584 14.1665H12.1417",
    stroke: "#475467",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.4edc07dbe258c4c23c31aff3fcfeeb85.svg";
export { ForwardRef as ReactComponent };